import { useProgram } from '../../../hooks/useProgram';
import { Channel, Program } from '../../../interfaces';
import { useAuth } from '../../../utils/auth-utils';
import channelPermissions from '../../../utils/channelPermissions';
import ProgramHeader from './PlaybillComponents/ProgramHeader';

interface Props {
  channel: Channel;
  program: Program;
  markers: JSX.Element;
}

export default function FutureProgram({ channel, program: propsProgram, markers }: Props) {
  const auth = useAuth();
  const program = useProgram(propsProgram);
  const permission = channelPermissions(channel, auth);
  const canPlay = program.canCatchup && !permission.locked && !auth.isGuest;

  return (
    <li className="tvGuideplaybillProgram future">
      <ProgramHeader
        id={program.id}
        name={program.name}
        channelId={program.channelid}
        startTime={program.startTime}
        episodeNumber={program.episodeNumber}
        canPlay={canPlay}
        markers={markers}
        extensionInfo={program.extensionInfo}
      />
    </li>
  );
}
